// serviceWorkerRegistration.ts

// This function is responsible for registering the service worker
export function register() {
	if ('serviceWorker' in navigator) {
		window.addEventListener('load', () => {
			const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
			navigator.serviceWorker
				.register(swUrl)
				.then((registration) => {
					console.log('Service Worker registered: ', registration);
				})
				.catch((error) => {
					console.log('Service Worker registration failed: ', error);
				});
		});
	}
}

// This function is responsible for unregistering the service worker
export function unregister() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready
			.then((registration) => {
				registration.unregister();
			})
			.catch((error) => {
				console.log('Service Worker unregister failed: ', error);
			});
	}
}

function urlBase64ToUint8Array(base64String: string) {
	const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);
	// eslint-disable-next-line no-plusplus
	for (let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}
	return outputArray;
}

export async function subscribeUserToPush() {
	if ('serviceWorker' in navigator && 'PushManager' in window) {
		const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
		if (!vapidKey) {
			throw new Error('VAPID public key is not defined in environment variables.');
		}
		const registration = await navigator.serviceWorker.ready;
		const subscription = await registration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: urlBase64ToUint8Array(vapidKey)
		});
		return subscription;
	}
	return null;
}

export async function unsubscribeUserFromPush(currentUser: any) {
	if ('serviceWorker' in navigator && 'PushManager' in window) {
		const registration = await navigator.serviceWorker.ready;
		const subscription = await registration.pushManager.getSubscription();
		if (subscription) {
			await subscription.unsubscribe();
			await fetch(`${process.env.REACT_APP_NEST_BACKEND_URL}/push/unsubscribe`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					hasuraKey: currentUser.hasuraKey,
					tipoUsuario: currentUser.tipoUsuario,
					endpoint: subscription.endpoint
				})
			});
		}
	}
}
